import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

class SelectComponent extends Component {
  render() {
    const { loadOptions, selectRef, ...other } = this.props;

    if (loadOptions) {
      return <ReactSelect.Async cache={false} loadOptions={loadOptions} ref={selectRef} {...other} />;
    }

    return <ReactSelect ref={selectRef} {...other} />;
  }
}

SelectComponent.propTypes = {
  loadOptions: PropTypes.func,
  selectRef: PropTypes.func,
};

export default SelectComponent;
